var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Tipo de unidad " + _vm._s(_vm.form.nombre))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout__controls" },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.permiteEditarTipoUnidad ||
                    _vm.permiteEliminarTipoUnidad,
                  expression:
                    "(permiteEditarTipoUnidad || permiteEliminarTipoUnidad)"
                }
              ],
              staticClass: "btn-info btn--bigger",
              on: {
                click: function($event) {
                  return _vm.$modal.show("tiposUnidad")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Buscar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "tiposUnidad",
                height: "auto",
                width: "60%",
                scrollable: ""
              }
            },
            [
              _c("lista-tipos-unidad", {
                attrs: {
                  editButton: false,
                  createButton: false,
                  deleteButton: false
                },
                on: { selected: _vm.selectedTipoUnidad }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "nombre",
                          placeholder: "Escriba un nombre..."
                        },
                        model: {
                          value: _vm.form.nombre,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "nombre", $$v)
                          },
                          expression: "form.nombre"
                        }
                      },
                      [
                        _c("span", [_vm._v("Nombre")]),
                        _vm._v(" "),
                        _vm.errores.nombre
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.nombre[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-xs-12 col-md-6" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "descripcion",
                        placeholder: "Escriba una descripción..."
                      },
                      model: {
                        value: _vm.form.descripcion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "descripcion", $$v)
                        },
                        expression: "form.descripcion"
                      }
                    },
                    [
                      _c("span", [_vm._v("Descripción")]),
                      _vm._v(" "),
                      _vm.errores.descripcion
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.errores.descripcion[0]) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.permiteCrearTipoUnidad && _vm.estado === "N") ||
                      (_vm.permiteEditarTipoUnidad && _vm.estado !== "N"),
                    expression:
                      "(permiteCrearTipoUnidad && estado === 'N') || (permiteEditarTipoUnidad && estado !== 'N')"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.permiteCrearTipoUnidad,
                    expression: "permiteCrearTipoUnidad"
                  }
                ],
                staticClass: "btn-light btn--text",
                attrs: { type: "button" },
                on: { click: _vm.crearNuevo }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", [_vm._v("Nuevo")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A" && _vm.permiteEliminarTipoUnidad,
                    expression: "estado === 'A' && permiteEliminarTipoUnidad"
                  }
                ],
                staticClass: "btn-danger btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminar }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Eliminar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "I" && _vm.permiteEliminarTipoUnidad,
                    expression: "estado === 'I' && permiteEliminarTipoUnidad"
                  }
                ],
                staticClass: "btn-dark btn--text",
                attrs: { type: "button" },
                on: { click: _vm.eliminar }
              },
              [
                _c("i", { staticClass: "fa fa-power-off" }),
                _vm._v(" "),
                _c("span", [_vm._v("Re-activar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del tipo de unidad")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edb0f7f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edb0f7f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/tipos-unidad/TipoUnidad.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-edb0f7f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/tipos-unidad/TipoUnidad.vue
// module chunks = 0